export default {
  name: "login",
  data() {
    return {}
  },
  mounted() {
    console.log("欢迎来到BQMA系统");
    const token = this.$route.query.token
    console.log(token)
    if(token){
      let data = {
        token:token
      }
      this.loginRequest(data)
    }else{
      this.token = ''
    }
  },
  methods: {
    loginRequest: function (data) {
      let _this = this
      this.$store.dispatch('user/login', data).then((res) => {
        this.$router.replace({path: '/'});
      }).catch(() => {
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.js